import React, { Component } from 'react';

import { MDBTable, MDBTableBody, MDBTableHead, MDBContainer } from 'mdbreact';
import { StyledInput, TitleContainer, Styledli } from './productTableComponents/styledCard';
import { sortMethods } from '../../utils/sort';
import RMAPopup from './productTableComponents/statusLogPopup';
import DetailCard from './DetailCard/DetailCard';
import ProductsList from './productsList/productsList.js';

//['Production Time', 'Mac Address', 'Serial Number', 'Location', 'Status', 'More', 'RMA', 'Ship']
class ProductTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      products: [],
      displayFields: ['Production Time', 'Mac Address', 'Serial Number', 'Location', 'Status', 'More', 'RMA'],
      editedDeviceId: '',
      editedDeviceItem: '',
      editedDeviceContent: '',
      searchbarContents: '',
      detailPopup: false,
      detialMacId: "0C9A42DFBAD7",
      detialSerial: '100WTB0083A003',
      statusArray: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      RMAPopup: false,
      focusedProduct: null
    };
  }

  componentDidMount() {
    this.fetchAll();
  }

  onTableChange( products ) {
    let statusArray = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    products.forEach((product, index) => {
      statusArray[Number(product.status)]++;
      product.createdAt = new Date(product.createdAt);
    })
    products.sort(sortMethods.timeReverse);
    this.setState({ products: products, statusArray: statusArray});
  }

  afterPutProduct( product ) {
    let index = this.state.products.findIndex((value, index, array) => {
      return value._id === product._id;
    })

    let newStatusArray = this.state.statusArray;
    newStatusArray[product.status]++;
    newStatusArray[this.state.products[index].status]--;

    let newProducts = this.state.products;
    product.createdAt = new Date(product.createdAt);
    newProducts[index] = product;

    this.setState({
      products: newProducts,
      statusArray: newStatusArray
    })
  }

  //fetch all products
  fetchAll() {
    fetch(`${global.gConfig.backend.url}/api/v1/medicamproduction`)
      .then( res => res.json())
      .then( products => { this.onTableChange(products); })
      .catch( err => {console.log(err)})
  }

  //When location or misc modification cancel
  onCancelClick = (e) => {
    if ( e.target.className.includes("cancel")) {
      this.setState({
        editedDeviceId: '',
        editedDeviceItem: '',
        editedDeviceContent: ''
      })
    }
  }

  //When location or misc textarea change
  ontextareaChange = (e) => {
    this.setState({editedDeviceContent: e.target.value})
  }

  //show the RMA panel
  onRMAToggle = (value) => {
    this.setState({RMAPopup: !this.state.RMAPopup, focusedProduct: value});
  }

  //RMA panel submit
  onRMASubmit = (contents) => {
    let {macAddress, serialNumber, status } = this.state.focusedProduct;
    fetch(`${global.gConfig.backend.url}/api/v1/devicestatelog`, {
      method: 'post',
      headers: {'Content-type': 'application/json'},
      body: JSON.stringify({
        macAddress: macAddress,
        serialNumber: serialNumber,
        content: contents,
        prevState: status,
        nextState: 3
      })
    })
      .then( res => res.json())
      .then( result => {
        this.onRMAToggle(null);
      })
      .catch(err => err)

    fetch(`${global.gConfig.backend.url}/medicamproduction/${this.state.focusedProduct._id}`, {
      method: 'put',
      headers: {'Content-type': 'application/json'},
      body: JSON.stringify( {status: 3} )
    })
      .then( res => res.json())
      .then( product => {
        this.afterPutProduct(product);
      });
  }

  //when location or misc modification done
  onSubmitClick = (e) => {
    var messageObj = {};
    var editedProd = this.state.products.filter((value, index, array) => {
      return value._id === this.state.editedDeviceId;
    })

    if ( this.state.editedDeviceItem === 'location' ) {
      messageObj = { location: this.state.editedDeviceContent }
    } else if (this.state.editedDeviceItem === 'misc') {
      messageObj = {
        prodNotes: {
          ...editedProd[0].prodNotes,
          misc: this.state.editedDeviceContent
        }
      }
    }

    fetch(`${global.gConfig.backend.url}/medicamproduction/${this.state.editedDeviceId}`, {
      method: 'put',
      headers: {'Content-type': 'application/json'},
      body: JSON.stringify( messageObj )
    })
      .then( res => res.json())
      .then( product => {
        let index = this.state.products.findIndex((value, index, array) => {
          return value._id === product._id;
        })

        let newProducts = this.state.products;
        product.createdAt = new Date(product.createdAt);
        newProducts[index] = product;

        this.setState({
          products: newProducts,
          editedDeviceId: '',
          editedDeviceItem: '',
          editedDeviceContent: ''});
        })
      .catch(err => {console.log(err)})
  }

  onDropdownClick = (e, product, statusNum) => {
    fetch(`${global.gConfig.backend.url}/api/v1/devicestatelog`, {
      method: 'post',
      headers: {'Content-type': 'application/json'},
      body: JSON.stringify({
        macAddress: product.macAddress,
        serialNumber: product.serialNumber,
        content: "--",
        prevState: product.status,
        nextState: statusNum
      })
    })
      .then( res => res.json())
      .then( result => {
        console.log(result);
      })
      .catch(err => err)

    fetch(`${global.gConfig.backend.url}/medicamproduction/${product._id}`, {
      method: 'put',
      headers: {'Content-type': 'application/json'},
      body: JSON.stringify( {status: statusNum} )
    })
      .then( res => res.json())
      .then( product => {
        this.afterPutProduct(product);
      });
  }

  //on Search bar Change wait for 1sec then fetch data from backend
  timmer = 0;

  onInputChange = (text) => {
    clearTimeout(this.timmer);
    this.setState({searchbarContents: text});

    this.timmer = setTimeout(() => {
      fetch(`${global.gConfig.backend.url}/api/v1/medicamproduction/?_query=true&_fields=macAddress,serialNumber&_regExp=${text}`)
        .then( res => res.json())
        .then( products => { this.onTableChange(products); })
        .catch( err => {console.log(err)})
    }, 1000);
  }

  //When status string is clicked
  onStatusCounterClick = (statusIndex) => {
    fetch(`${global.gConfig.backend.url}/api/v1/medicamproduction?_query=true&_fields=status&_number=${statusIndex}`)
      .then( res => res.json())
      .then( products => {
        this.onTableChange( products );
      })
      .catch( err => {console.log(err)})
  }

  //when location or misc is clicked
  onEditButtonClick = ( e, macNumber, item, content ) => {
    if ( !e.target.className.includes("cancel") && e.target.nodeName !== 'TEXTAREA') {
      this.setState({editedDeviceId: macNumber, editedDeviceItem: item, editedDeviceContent: content});
    }
  }

  //on Info Icon click
  onInfoClick = (value) => {
    this.setState({detailPopup: true, detialMacId: value.macAddress})
  }
  // When detail card close
  onDetialCancel = (e) => { this.setState({detailPopup: false}); }

  render() {
    const { statusArray, products, searchbarContents, detailPopup, detialMacId, detialSerial, displayFields,
    editedDeviceId, editedDeviceItem, editedDeviceContent} = this.state;
    return (
      <MDBContainer fluid style={{maxWidth: "100%",overflowX: "scroll"}}>
        { detailPopup ? <DetailCard detialMacId={detialMacId}  detialSerial={detialSerial} onDetialCancel={this.onDetialCancel}/> : null}
        <TitleContainer>
          <h1 className="col-sm-8" style={{fontWeight: "bold", color: "#ffca28"}}>Medicam Production</h1>
          <StyledInput
            className="col-sm-4"
            type="search"
            value={searchbarContents}
            placeholder="Searching for mac, serial number"
            onChange={(e) => {this.onInputChange(e.target.value)}}>
          </StyledInput>
        </TitleContainer>
        <MDBContainer fluid>
          <ul style={{display: "flex", flexWrap: "wrap"}} className="list-unstyled">
            <Styledli onClick={() => {this.fetchAll()}}>{`Total: ${products.length}`}</Styledli>
            {global.gConfig.statusIndex.map((value, index) => (
              <Styledli key={`counter ${value}`} onClick={()=>{this.onStatusCounterClick(index)}}>
                {`${value}: ${statusArray[index]}`}
              </Styledli>
            ))}
          </ul>
        </MDBContainer>
        <MDBTable className="table table-sm " style={{maxWidth: "100%",overflow: "scroll"}}>
          <MDBTableHead color="amber lighten-2" textWhite>
            <tr>
              {displayFields.map((value, index, array) => {
                return <th key={index}>{value}</th>
              })}
            </tr>
          </MDBTableHead>
          <MDBTableBody color="#f8f9fa">
            <ProductsList
              products={products}
              editedDeviceId={editedDeviceId}
              editedDeviceItem={editedDeviceItem}
              editedDeviceContent={editedDeviceContent}
              onEditButtonClick={this.onEditButtonClick}
              onDropdownClick={this.onDropdownClick}
              ontextareaChange={this.ontextareaChange}
              onSubmitClick={this.onSubmitClick}
              onCancelClick={this.onCancelClick}
              onRMAToggle={this.onRMAToggle}
              setState={this.setState}
              onInfoClick= {this.onInfoClick}
            />
          </MDBTableBody>
        </MDBTable>
        <RMAPopup RMAPopup={this.state.RMAPopup} toggle={this.onRMAToggle} onRMASubmit={this.onRMASubmit}/>
      </MDBContainer>
    );
  }
}

export default ProductTable;
